module.exports = __webpack_public_path__ + "static/media/tech-stack.d36e5ab2.png";